import classes from './Feed.module.css';

const News = () =>{
  return(
    <div>
      News
    </div>
  );
}

export default News;